import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PontotelSeletor = _resolveComponent("PontotelSeletor")!

  return (_openBlock(), _createBlock(_component_PontotelSeletor, _mergeProps($setup.propriedadesSeletor, {
    "model-value": $setup.estadoSeletor,
    tamanho: $props.tamanho,
    "carregar-itens": null,
    "selecao-multipla": $props.selecaoMultipla,
    desabilitado: $props.desabilitado,
    "modo-exibicao": $props.somenteLeitura,
    "permite-selecionar-todos": $props.permiteSelecionarTodos,
    "habilitar-duplo-clique": $props.habilitarDuploClique,
    info: $props.info,
    "recarregar-todos": !$props.somenteLeitura,
    "recarregando-todos": $setup.catalogo.atualizando.value,
    "onUpdate:modelValue": $setup.alterarSelecao,
    onFiltrandoItens: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('filtrando-itens', $event))),
    onDuploClique: $setup.tratarDuploClique,
    "onUpdate:selecionouTodos": _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('update:selecionouTodos', $event))),
    onRecarregarTodos: $setup.catalogo.atualizar
  }), _createSlots({ _: 2 /* DYNAMIC */ }, [
    (_ctx.$slots.icone)
      ? {
          name: "icone",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "icone")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["model-value", "tamanho", "selecao-multipla", "desabilitado", "modo-exibicao", "permite-selecionar-todos", "habilitar-duplo-clique", "info", "recarregar-todos", "recarregando-todos", "onRecarregarTodos"]))
}